module.exports = __webpack_public_path__ + "img/attach-pdf.7ccebb3f.svg";